function getAlignProps(type, props) {
    var _a;
    var styles = {};
    if (props.stretch === true)
        props.align = 'stretch';
    else if (props.center === true)
        props.align = 'center';
    else if (props.start === true)
        props.align = 'flex-start';
    else if (props.end === true)
        props.align = 'flex-end';
    if (props.alignContent)
        styles.alignContent = props.alignContent;
    if (props.alignItems)
        styles.alignItems = props.alignItems;
    if (props.alignSelf)
        styles.alignSelf = props.alignSelf;
    var classes = (_a = {},
        _a["align-flex-".concat(type, "-").concat(props.align || 'none')] = !!props.align,
        _a);
    return {
        classes: classes,
        props: {},
        styles: styles,
        variables: {}
    };
}
export function getAlignRowProps(props) {
    return getAlignProps('container', props);
}
export function getAlignColProps(props) {
    return getAlignProps('col', props);
}
function getJustifyProps(type, props) {
    var _a;
    var styles = {};
    if (props.justifyStart === true)
        props.justify = 'flex-start';
    else if (props.justifyEnd === true)
        props.justify = 'flex-end';
    else if (props.justifyCenter === true)
        props.justify = 'center';
    else if (props.justifyBetween === true)
        props.justify = 'space-between';
    else if (props.justifyAround === true)
        props.justify = 'space-around';
    if (props.justifyContent)
        styles.justifyContent = props.justifyContent;
    if (props.justifyItems)
        styles.justifyItems = props.justifyItems;
    if (props.justifySelf)
        styles.justifySelf = props.justifySelf;
    var classes = (_a = {},
        _a["justify-flex-".concat(type, "-").concat(props.justify || 'none')] = !!props.justify,
        _a);
    return {
        classes: classes,
        props: {},
        styles: styles,
        variables: {}
    };
}
export function getJustifyColProps(props) {
    return getJustifyProps('col', props);
}
export function getJustifyRowProps(props) {
    return getJustifyProps('container', props);
}
